import React, {useEffect, useState} from 'react';
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";
import {Building} from "../../../types/Building";

type Props = {
    building: Building | null
    show: boolean
    onDelete?: (building: Building) => any
    onDeleteFail?: (building: Building, error: unknown) => any
    onCancel?: () => any
}

function DeleteBuilding(props: Props) {
    const {building, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(building?.name || 'this building');
    const {mutateAsync: deleteBuilding} = useMutation(ngage.buildings.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(building) setName(building.name)
    }, [building]);

    async function handleDeleteBuilding() {
        if (building) {
            try {
                await deleteBuilding(building.id)
                await invalidate('buildings.all')

                notify("success", "Building Deleted", `${building.name} has been permanently removed`)
                if (onDelete) onDelete(building)
            } catch (error) {
                notify("error", "Building Not Deleted", `${building.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(building, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Building"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteBuilding}
            onCancel={handleCancel}
        />
    );
}

export default DeleteBuilding;